import { useEffect, useRef, useState } from "react";

const ViewTimer = ({
  creditId,
  viewName,
  description,
  pathView,
  hasSuccess = true,
  errorMessage = "",
  onSaveTimeline,
  idOperation = null
}) => {
  const [isActive, setIsActive] = useState(true); // Estado de visibilidad
  const totalSecondsRef = useRef(0);
  const lastStartRef = useRef(Date.now());
  const isActiveRef = useRef(isActive);
  isActiveRef.current = isActive;
  const propsRef = useRef({
    creditId,
    viewName,
    description,
    pathView,
    hasSuccess,
    errorMessage,
    onSaveTimeline,
    idOperation,
  });
  propsRef.current = {
    creditId,
    viewName,
    description,
    pathView,
    hasSuccess,
    errorMessage,
    onSaveTimeline,
    idOperation,
  };

  useEffect(() => {
    //Detectar si el usuario cambia de pestaña
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Pausa el contador
        pauseTimer();
      } else {
        // Reanuda el contador
        resumeTimer();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      // Antes de desmontar, aseguramos que el tiempo esté actualizado
      if (isActiveRef.current) pauseTimer();

      const {
        creditId,
        viewName,
        description,
        pathView,
        hasSuccess,
        errorMessage,
        onSaveTimeline,
        idOperation,
      } = propsRef.current;

      const payloadTimeline = {
        name: viewName,
        description,
        pathView,
        timeSpent: totalSecondsRef.current, //tiempo total activo
        error: {
          hasError: !hasSuccess,
          errorMessage: errorMessage
        },
        success: {
          hasSuccess,
          successMessage: "Ok"
        },
        styles: {
          TimelineOppositeContent: {
            sx: { m: "auto 0" },
            align: "right",
            variant: "body2",
            color: "text.secondary",
            style: { fontFamily: "GT Walsheim Pro", fontWeight: "lighter" }
          },
          TimelineDot: { color: "" },
          TimelineContent: {
            Typography: { variant: "h6", component: "span" },
            sx: { py: "12px", px: 2 }
          },
          icon: {
            name: "CiBoxList",
            size: "1.5rem"
          }
        }
      };

      // Guarda en backend
      if (onSaveTimeline && creditId) {
        onSaveTimeline(creditId, payloadTimeline, idOperation);
      }

      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
    // Efecto de montaje/desmontaje único: el cleanup lee las props/estado vigentes vía
    // propsRef/isActiveRef (no como dependencias) para enviar un solo evento de tiempo-en-página
    // al desmontar, con los valores más recientes. Agregar estas props como deps del efecto
    // dispararía onSaveTimeline de forma prematura/duplicada.
  }, []);

  // Pausa el contador
  const pauseTimer = () => {
    const now = Date.now();
    const seconds = Math.floor((now - lastStartRef.current) / 1000);
    totalSecondsRef.current += seconds;
    setIsActive(false);
  };

  // Reanuda el contador
  const resumeTimer = () => {
    lastStartRef.current = Date.now();
    setIsActive(true);
  };

  return null; // No renderiza nada visual
};

export default ViewTimer;
